(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class CartDiscountFallback extends HTMLElement {
    #controller = null;
    #requestController = null;

    connectedCallback() {
      this.#controller = new AbortController();
      const { signal } = this.#controller;
      this.input = this.querySelector('[data-discount-input]');
      this.applyButton = this.querySelector('[data-discount-apply]');
      this.messageEl = this.querySelector('[data-discount-message]');
      this.cartUpdateUrl = this.dataset.cartUpdateUrl || '/cart/update.js';

      this.applyButton?.addEventListener('click', () => this.#apply(), { signal });
      this.input?.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        this.#apply();
      }, { signal });
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#requestController?.abort();
    }

    get #code() {
      return (this.input?.value || '').trim().toUpperCase();
    }

    #hasAppliedCode(root, code) {
      return Array.from(root.querySelectorAll('[data-applied-discount-title]')).some(
        (element) => element.dataset.appliedDiscountTitle === code
      );
    }

    async #apply() {
      const code = this.#code;
      if (!code) {
        this.#showMessage(this.dataset.emptyMessage, 'error');
        this.input?.focus();
        return;
      }

      if (this.#hasAppliedCode(this, code)) {
        this.#showMessage(this.dataset.appliedMessage.replace('[code]', code), 'success');
        return;
      }

      this.#clearMessage();
      this.#setBusy(true);
      this.#requestController?.abort();
      this.#requestController = new AbortController();

      try {
        const response = await fetch(this.cartUpdateUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ discount: code }),
          signal: this.#requestController.signal,
        });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const cart = await response.json();
        const appliedCode = cart.discount_codes?.find(
          (discount) => discount.code?.toUpperCase() === code
        );

        if (!appliedCode?.applicable) {
          this.#showMessage(this.dataset.invalidMessage, 'error');
          return;
        }

        this.#showMessage(this.dataset.appliedMessage.replace('[code]', code), 'success');
        if (this.input) this.input.value = '';
        if (typeof window.publish === 'function') {
          await window.publish('cart-update', { source: 'cart-discount' });
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.#showMessage(this.dataset.networkMessage, 'error');
      } finally {
        this.#setBusy(false);
      }
    }

    #setBusy(state) {
      if (!this.applyButton) return;
      this.applyButton.setAttribute('aria-busy', state ? 'true' : 'false');
      this.applyButton.disabled = state;
    }

    #showMessage(message, state) {
      if (!this.messageEl) return;
      this.messageEl.hidden = false;
      this.messageEl.dataset.state = state;
      this.messageEl.setAttribute('role', state === 'error' ? 'alert' : 'status');
      this.messageEl.textContent = message || '';
      this.input?.setAttribute('aria-invalid', state === 'error' ? 'true' : 'false');
    }

    #clearMessage() {
      if (!this.messageEl) return;
      this.messageEl.hidden = true;
      this.messageEl.removeAttribute('data-state');
      this.messageEl.textContent = '';
      this.input?.removeAttribute('aria-invalid');
    }
  }

  if (!customElements.get('cart-discount')) {
    customElements.define('cart-discount', CartDiscountFallback);
  }
  } catch(e) { console.error(e); }
})();

})();
